import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Book = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M4.5 5C4.5 3.34315 5.84315 2 7.5 2H18.5C19.0523 2 19.5 2.44772 19.5 3V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5H14.5V17.5H17.5V15.5H7.5C6.94772 15.5 6.5 15.9477 6.5 16.5C6.5 17.0523 6.94772 17.5 7.5 17.5V19.5C5.84315 19.5 4.5 18.1569 4.5 16.5V5ZM17.5 4V13.5H7.5C7.14936 13.5 6.81278 13.5602 6.5 13.6707V5C6.5 4.44772 6.94772 4 7.5 4H17.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path d="M11 20.5L8.5 22V17H13.5V22L11 20.5Z" fill="currentColor" />
  </Icon>
));

export default Book;
